// extracted by mini-css-extract-plugin
export default {"container":"FormButton_container__3Pui-","defaultBtn":"FormButton_defaultBtn__RaLT2","redBtn":"FormButton_redBtn__KvqRd","whiteBtn":"FormButton_whiteBtn__whJvN"};